<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-06-28 14:48:52
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-25 17:02:37
 * @FilePath: \合联\oms\src\view\system\department\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getDepartment,
  add,
  getDetails,
  update,
  del,
  sales,
  salesSave,
  delSales,
} from "@/api/system/department";
import cTable from "@/base/common/index";
export default {
  name: "department",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: getDepartment,
        getDetails,
        del,
        add,
        update,
        sales,
        salesSave,
        delSales,
        afterHandleList() {
          this.getTable().setAllTreeExpand(true);
        },
      },
      config: {
        height: 630,
        treeConfig: {
          children: "children",
          expandAll: true,
        },
      },
      modals: {
        addSales: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("salesSave", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              parent_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              user_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ parent_id: 24 }, { user_id: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$tz("上级"),
              key: "parent_id",
              component: "Select",
              placeholder: () => this.$tz("上级"),
              options: [],
              optionsFn: "",
              optionsKey: "",
              disabled() {
                return this.$modal.params.child;
              },
              default: 0,
              methods: {
                list({ field }) {
                  field.options = this.$page.getModal("sales").list.reduce(
                    (a, b) => {
                      a.push({ label: b.userInfo.realname, value: b.id });
                      b.children.forEach((c) => {
                        a.push({ label: c.userInfo.realname, value: c.id });
                      });
                      return a;
                    },
                    [{ label: "无", value: 0 }]
                  );
                },
              },
            },
            {
              name: this.$tz("销售名称"),
              key: "user_id",
              component: "Select",
              placeholder: () => this.$tz("销售名称"),
              options: [],
              optionsFn: "salesman",
              optionsKey: "",
              default: "",
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2, maxRows: 4 },
              },
            },
          ],
        },
        sales: {
          methods: {
            afterHandleList() {
              this.getTable().setAllTreeExpand(true);
            },
          },
          config: {
            listFn: "sales",
            title: this.$tz("销售团队"),
            modalBind: {
              width: 1000,
            },
          },
          footer: {
            show: () => false,
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$tz("新增"),
                type: "add",
                fnName: "add",
                bind: {
                  type: "primary",
                },
              },
            ],
            methods: {
              add() {
                this.$page.getModal("addSales").open(null);
              },
            },
          },
          table: {
            config: {
              height: 600,
              treeConfig: {
                children: "children",
                expandAll: true,
              },
            },
            fields: [
              {
                name: () => this.$tz("销售名称"),
                key: "userInfo.realname",
                minWidth: 200,
                columnBind: {
                  "tree-node": true,
                },
              },
              {
                name: () => this.$tz("所属公司"),
                key: "userInfo.ownership_name",
                minWidth: 110,
              },
              {
                name: () => this.$tz("备注"),
                key: "remarks",
                minWidth: 110,
              },
              {
                name: () => this.$tz("排序值"),
                key: "sort",
                minWidth: 110,
              },
              {
                name: () => this.$tz("最后更新时间"),
                key: "update_time",
                minWidth: 110,
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 220,
                fixed: "right",
                list: [
                  {
                    name: this.$t("child"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "primary",
                    },
                  },
                  {
                    name: () => this.$tz("删除"),
                    type: "del",
                    fnName: "del",
                    bind: {
                      type: "error",
                    },
                  },
                ],
                methods: {
                  del({ row }) {
                    this.$Modal.confirm({
                      title: this.$tz("删除"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods(
                          "delSales",
                          row.id,
                          true,
                          true
                        ).then((res) => {
                          this.getList();
                        });
                      },
                    });
                  },
                  add({ row }) {
                    this.getModal("addSales").open({
                      parent_id: row.id,
                      child: true,
                    });
                  },
                },
              },
            ],
          },
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur",
                },
                {
                  min: 3,
                  max: 155,
                  message: "Please enter 3 to 155 characters",
                  trigger: "blur",
                },
              ],
              parent_id: [
                {
                  required: true,
                  type: "number",
                  message: "parent cannot be empty",
                  trigger: "change",
                },
              ],
              types: [
                {
                  required: true,
                  type: "number",
                  message: "type cannot be empty",
                  trigger: "change",
                },
              ],
              remarks: [
                {
                  required: true,
                  message: "Description cannot be empty",
                  trigger: "blur",
                },
                {
                  max: 155,
                  message: "Please enter maximum length 155",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ title: 24 }, { sort: 24 }, { remarks: 24 }, { types: 24 }],
          fields: [
            {
              name: () => this.$t("deName"),
              key: "title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("deName"),
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
            },
            {
              name: () => this.$t("type"),
              key: "types",
              component: "Radio",
              options: [
                { label: this.$t("hq"), value: 1 },
                { label: this.$t("branchOffice"), value: 2 },
                { label: this.$t("assistDepartment"), value: 3 },
                { label: this.$t("job"), value: 4 },
              ],
              bind: {
                border: true,
              },
            },
          ],
        },
      },
      footer: { show: () => false },
      header: {
        // searchs: [
        //   {
        //     key: "keywords",
        //     placeholder() {
        //       return this.$t("keyword");
        //     },
        //     component: "Input"
        //     // bind: {
        //     //   type: "textarea",
        //     //   autosize: { minRows: 2, maxRows: 2 }
        //     // }
        //   }
        // ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$tz("销售团队"),
              type: "sales",
              fnName: "sales",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            sales() {
              this.getModal("sales").open(null, function () {
                this.getList();
              });
            },
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("deName"),
          key: "title",
          align: "left",
          minWidth: 200,
          columnBind: {
            "tree-node": true,
          },
        },
        {
          name: () => this.$t("deParent"),
          align: "left",
          key: "department_title",
          minWidth: 160,
        },
        {
          name: () => this.$t("deSc"),
          key: "remarks",
          align: "left",
          minWidth: 150,
        },
        {
          name: () => this.$t("type"),
          key: "types",
          width: 80,
          methods: {
            render({ value }) {
              let options = [
                { label: this.$t("hq"), value: 1 },
                { label: this.$t("branchOffice"), value: 2 },
                { label: this.$t("assistDepartment"), value: 3 },
                { label: this.$t("job"), value: 4 },
              ];
              return options.find((item) => item.value === value).label;
            },
          },
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          width: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170,
        },
        // {
        //   name: this.$t("operation"),
        //   slot: "addOperation",
        //   align: "center",
        //   width: 300
        // },
        // {
        //   name: this.$t("contraband_code"),
        //   key: "contraband_code",
        //   align: "center"
        // },
        // {
        //   name: this.$t("contraband_description"),
        //   key: "contraband_description",
        //   align: "center"
        // },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: this.$t("child"),
              type: "add",
              fnName: "add",
              bind: {
                type: "warning",
              },
              icon: "md-add",
              id: 149,
              // disabled({ row }) {
              //   console.log(row);
              // }
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 150,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 151,
              // bind: {
              //   type: "error"
              // }
            },
          ],
          methods: {
            add({ row }) {
              // this.handleRequestMethods("getDetails", row.id).then(res => {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").type = "add";
              this.getModal("add").open({ parent_id: row.id });
              // });
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
